import React from 'react'
import { Card } from 'react-bootstrap'

const ServiceItem = ({ data }) => {
    return (
        <div className='service-item'>
            <Card>
                <Card.Img variant="top" src={require(`./../../assets/images/${data?.img}`)} />
                <Card.Body>
                    <Card.Title>{data?.title}</Card.Title>
                    <Card.Text>
                        {data?.des}
                    </Card.Text>
                </Card.Body>
            </Card>
        </div>
    )
}

export default ServiceItem